export default "__VITE_ASSET__DxwKqoKG__"